export default __webpack_public_path__ + "static/media/product.d0d25872.webp";